<header class=" microsite-header pt-2" data-component-version="1" data-alignment="bottom" data-has-search="false"
    data-in-page-nav="false" data-colored-menu="false">
    <div class=" wrap">
        <nav class="microsite-header-nav navbar navbar-expand-lg navbar-light p-0 w-100 d-flex justify-content-between">
            <div *ngIf="isLoggedIn" style="display:flex;justify-content: center;align-items: center;">
                <button class="navbar-toggler" type="button" (click)="toggleMobileMenu(); $event.stopPropagation()"
                    [attr.aria-expanded]="!isNavCollapsed" data-target="#navbarMenu" aria-controls="navbarMenu"
                    aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                    <i class="fa fa-times" aria-hidden="true"></i>
                </button>
                <div class="logo d-none d-lg-block account-hover cursor-pointer">
                    <div class="d-flex align-items-center" (click)="toggleDropdown(); $event.stopPropagation()">
                        <div class="profile-icon mr-2">
                            <img src="/user.png" alt="" class="img-fluid rounded-circle">
                        </div>
                        <strong class="text-dark">{{userDetails?.userName}}</strong>
                    </div>

                </div>
            </div>
           

        </nav>
        <div class="microsite-logos">
            <a class="brand-link cursor-pointer">
                <img src="https://assets.syngentaebiz.com/images/prod_logos/Storen_RGB.svg" alt="Storen"
                    (click)="redirectHome()" />
            </a>
            <span class="spacer"></span>
            <a href="https://www.syngenta-us.com/" target="_blank" class="syngenta-link">
                <img src="https://assets.syngentaebiz.com/images/media/logo-syngenta-united-states.svg"
                    alt="Syngenta US" />
            </a>
        </div>
    </div>

    <div *ngIf="submenuOpen" class="dropdown-menu show desktopView bg-light-green rounded-0 m-0 p-0 cursor-pointer"
        [style.width.rem]="15">
        <div class="storenDesktopHeadermenu">
            <ul class="align-items-center text-left text-dark p-0 m-0">
                <li class="w-100 px-1 font-width-bold py-2">
                    <a class="p-2 text-white"(click)="signOut()">Logout</a>
                </li>
            </ul>
        </div>
    </div>

    <div class="collapse navbar-collapse mobileView" id="navbarMenu" [class.show]="mobileMenuOpen">
        <div class="storenHeadermenu">
        <ul class="align-items-center text-left text-dark p-0 m-0">
            <li class="nav-item px-1 font-width-bold d-flex justify-content-between align-items-center toogle-sub-menu"
            data-toggle="collapse" data-target="#homeContent" aria-expanded="false">
            <a class="px-2 text-dark d-flex align-items-center" href="javascript:void(0)">
              <div class="profile-icon mr-2 ">
                <img src="/user.png"  alt="" class="img-fluid rounded-circle">
              </div>
              <strong class="text-white">{{userDetails?.userName}}</strong>
            </a>
            <i class="fa fa-angle-down text-dark px-2 collapsed" [style.font-size.px]="35"></i>
            <i class="fa fa-angle-up text-dark px-2 expanded" [style.font-size.px]="35"></i>
          </li>
          <div id="homeContent" class="collapse">
            <li class="nav-item w-100 px-1 font-width-bold py-2 mobileColor">
                <a class="p-2 text-white"(click)="signOut()">Logout</a>
            </li>
        </div>
        </ul>
    </div>
    </div>
</header>


<header class="ssp-header-banner h-[425px] sm:h-[300px] flex" *ngIf="currentSurveyStep==1">
    <ng-container *ngIf="!isEnrollmentClosed ">
        <!-- For default -->
        <section class="container mx-auto max-w-screen-xl mt-8 sm:m-auto px-8 xl:px-0 leading-tight">
            <span
                class="ssp-header-text-small text-[22px] md:text-[24px] lg:text-[34px] xl:w-6/12 lg:w-5/12 md:w-4/12 sm:w-full">Welcome
                to your</span>
            <span
                class="ssp-header-text-large text-[32px] md:text-[36px] lg:text-[50px] xl:w-6/12 lg:w-5/12 md:w-4/12 sm:w-full">STOREN
                SATISFACTION
                DASHBOARD</span>
        </section>
    </ng-container>

    <ng-container *ngIf="isEnrollmentClosed ">
        <!-- For enrollment closed -->
        <section class="container mx-auto max-w-screen-xl mt-8 sm:m-auto px-8 xl:px-0 leading-tight mytitle">
            <span class="ssp-header-text-large mainTitle">Enrollment
                Closed</span>
            <span class="ssp-header-text-small subTitle">Thank you for your interest in the Storen Satisfaction
                Program.</span>
        </section>
    </ng-container>

</header>

<!-- <header class="ssp-header-banner h-[425px] sm:h-[300px] flex">
    <section class="container mx-auto max-w-screen-xl mt-8 sm:m-auto px-8 xl:px-0 leading-tight mytitle">
        <span
            class="ssp-header-text-large mainTitle">Enrollment
            Closed</span>
        <span
            class="ssp-header-text-small subTitle">Thank you for your interest in the Storen Satisfaction Program.</span>
    </section>
</header> -->


<tui-root>
    <header *ngIf="currentSurveyStep > 1 && !hideSteps">
        <section class="ssp-narrow-header py-[36px] flex">
            <div class="container">
                <p class="text-center text-white font-bold text-[26px] mb-[18px] headerStyle"
                    style="line-height: normal;">{{ steps[currentSurveyStep - 1].heading }}</p>
                <p class="text-center text-white text-[18px]">{{ steps[currentSurveyStep - 1].subheading }}</p>
            </div>
        </section>
    </header>

    <div class="steps-section pt-6 text-white" *ngIf="!hideSteps">
        <div class="md:flex hidden justify-between w-full relative">
            <div *ngFor="let step of steps" class="flex-1 flex flex-col items-center relative">

                <p *ngIf="currentStep === step.id" class="text-[12px] uppercase mb-2 absolute -top-6 text-[#FFFFFF]">
                    YOU ARE HERE
                </p>

                <div class="w-14 h-14 flex items-center justify-center">
                    <img [src]="getStepImage(step.id)" [alt]="step.title">
                </div>

                <p class="text-[12px] mt-2 font-bold"
                    [ngClass]="{'text-[#FFFFFF]': currentStep === step.id, 'text-[#FFFFFF99]': currentStep !== step.id}">
                    STEP {{ step.id }}
                </p>

                <p class="text-[12px]"
                    [ngClass]="{'text-[#FFFFFF]': currentStep === step.id, 'text-[#FFFFFF99]': currentStep !== step.id}">
                    {{ step.title }}
                </p>
            </div>
        </div>

        <!-- Mobile view -->
        <div class="block md:hidden w-full px-2">
            <div class="flex w-full mb-4">
                <ng-container *ngFor="let step of steps">
                    <div *ngIf="currentMobileStep === step.id" class="flex items-center text-left flex-1 gap-2">
                        <div class="w-14 h-14">
                            <img [src]="step.image" [alt]="step.title">
                        </div>
                        <div class="">
                            <p class="text-[14px] font-bold text-[#FFFFFF]">
                                STEP {{ step.id }}:
                            </p>
                            <p class="text-[20px] font-bold text-[#FFFFFF]">
                                {{ step.title }}
                            </p>
                        </div>
                    </div>
                </ng-container>
            </div>

            <!-- Progress bar for mobile -->
            <div class="flex w-full">
                <ng-container *ngFor="let step of steps">
                    <div class="text-center flex-1 mx-1">
                        <span class="text-white">
                            <progress tuiProgressBar size="s" [value]="step.status=='COMPLETED'" max="1"
                                class="storen-gold"></progress>
                        </span>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</tui-root>